import React from 'react';
import { CellContext } from '@tanstack/react-table';
import { MetricProps, formatMetricValue } from '../../utils';
import LongContentPopover from '@hud/web-components/LongContentPopover/LongContentPopover';

export function formatMetric<TData>(
  format: MetricProps['format'],
) {
  return function cellFormatter(cell: CellContext<TData, number>) {
    const value: number = cell.getValue();
    return formatMetricValue({
      value,
      format,
    });
  };
}

export default function renderMetric<TData, TValue extends number>(
  format: MetricProps['format'],
) {
  const formatter = formatMetric<TData>(format);
  return function cellRenderer(cell: CellContext<TData, TValue>) {
    return <LongContentPopover>{formatter(cell)}</LongContentPopover>;
  };
}